export enum WaitingListLeadState {
    // Waiting list lead was added and can be acquired by supplier via AnfrageManager
    Open = 0,
    // Waiting list lead was acquired by supplier and is visible for supplier
    Acquired = 1,
    // Waiting list lead was rejected by supplier
    Rejected = 3
}
